module.exports = "/_next/static/images/5a565c762134771fb52a168684b97679-man-sitting-with-notebook@xs-2x.jpg.webp";